import {
  consumptionPointSchema,
  contractTypeSchema,
  noticePeriodSchema,
  nonPrefixedEanSchema,
  fixedTermContractSchema,
  distributionAreaOptions,
  completeDistributionTariffOptions,
} from "@nano-portal/customers"
import { z } from "zod"
import { dateSchema, fileSchema } from "../utils"
import { useSafeLocalStorage } from "../../../../../utils/localStorage"
import { objectKeysToZodEnum } from "@nano-portal/shared"
import { terminationOptionsSchema } from "../acquisitionForm.utils"
import { useFormContext } from "react-hook-form"

const distributionTariffSchema = objectKeysToZodEnum(completeDistributionTariffOptions, {
  errorMap: () => ({ message: "Tato hodnota nesmí být prázdná" }),
})

const distributionAreaSchema = objectKeysToZodEnum(distributionAreaOptions, {
  errorMap: () => ({
    message: "Tato hodnota nesmí být prázdná",
  }),
})

export const consumptionPointFormSchema = z.object({
  ean: nonPrefixedEanSchema,
  distributionTariff: distributionTariffSchema,
  distributionArea: distributionAreaSchema,
  circuitBreakerPhases: consumptionPointSchema.shape.circuitBreaker.shape.phases,
  circuitBreakerCapacity: consumptionPointSchema.shape.circuitBreaker.shape.capacity,

  highTariffConsumptionKWh: consumptionPointSchema.shape.highTariffConsumptionKWh,
  lowTariffConsumptionKWh: consumptionPointSchema.shape.lowTariffConsumptionKWh.nullish(),

  currentSupplier: consumptionPointSchema.shape.currentSupplier,

  contractInfo: z.discriminatedUnion("terminationOption", [
    z.object({
      terminationOption: z.literal(terminationOptionsSchema.Values.DO_NOT_TERMINATE),

      contractEndDate: dateSchema.shape.date,
      contractEndMonth: dateSchema.shape.month,
      contractEndYear: dateSchema.shape.year,

      contractTermination: fileSchema.optional(),
    }),
    z.object({
      terminationOption: z.literal(terminationOptionsSchema.Values.TERMINATE),
      currentContract: z.discriminatedUnion(
        "contractType",
        [
          z.object({
            contractType: z.literal(contractTypeSchema.Values.VARIABLE_TERM),

            noticePeriod: noticePeriodSchema,
          }),
          z.object({
            contractType: z.literal(contractTypeSchema.Values.FIXED_TERM),

            contractEndDate: dateSchema.shape.date,
            contractEndMonth: dateSchema.shape.month,
            contractEndYear: dateSchema.shape.year,
            terminationNoticeInDaysBeforeEnd: fixedTermContractSchema.shape.terminationNoticeInDaysBeforeEnd,
          }),
        ],
        {
          errorMap: () => ({
            message: "Tato hodnota nesmí být prázdná",
          }),
        }
      ),
    }),
  ]),

  lastBilling: fileSchema,
})

export type ConsumptionPointFormValues = z.infer<typeof consumptionPointFormSchema>

export function useStoredConsumptionPointFormValues() {
  return useSafeLocalStorage({ key: "acquisition-form-consumption-point", schema: consumptionPointFormSchema })
}

export function useConsumptionPointFormContext() {
  return useFormContext<ConsumptionPointFormValues>()
}
